import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core'
import { CentricTypography } from '@core/component/CentricTypography'
import classNames from 'classnames'

interface IAReadOnlyFieldProps {
  label: string
  value: number | string
  noBottomBorder?: boolean
  containerClass?: any
}
const useStyles = makeStyles(theme => ({
  cellField: {
    width: '100%',
    height: 65,
    padding: '10px 10px 10px 10px',
    textAlign: 'center',
    borderBottom: '1px solid #eeeeee'
  },
  noBottomBorder: {
    borderBottom: 'none'
  },
  cellFieldLabel: {
    marginBottom: 4
  }
}))

const IAReadOnlyField: FC<IAReadOnlyFieldProps> = ({
  label,
  value,
  noBottomBorder,
  containerClass
}) =>
  useObserver(function useHook() {
    const classes = useStyles()

    return (
      <div
        className={classNames(classes.cellField, containerClass, {
          [classes.noBottomBorder]: noBottomBorder
        })}
      >
        <CentricTypography variant={'body2'} className={classes.cellFieldLabel}>
          {label}
        </CentricTypography>
        <CentricTypography variant={'h6DarkGrey'}>{value}</CentricTypography>
      </div>
    )
  })

export default IAReadOnlyField
